import './styles/LockedDepartments.scss';

import { useMutation } from '@apollo/client';
import { Chip, Grid, Paper, TextField, Autocomplete } from '@mui/material';

import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import UPDATE_LOCKED_DEPARTMENTS from 'gql/mutations/updateLockedDepartments.gql';

import { translations } from 'locales/i18n';
import { Department, LockedDepartments as ILockedDepartments } from 'types/AppTypes';

interface Props {
  lockedDepartments: ILockedDepartments;
  departments: Department[];
}

export default function LockedDepartments({ lockedDepartments, departments }: Props): ReactElement {
  const { t } = useTranslation();
  const [selectedDepartments, setSelectedDepartments] = useState(lockedDepartments.departments);
  const [loading, setLoading] = useState(false);
  const [updateLockedDepartments] = useMutation<
    ILockedDepartments,
    { id: string | number; data: { departments: number[] } }
  >(UPDATE_LOCKED_DEPARTMENTS);
  const onDepartmentChange = async (ev, values) => {
    if (!loading) {
      setLoading(true);
      setSelectedDepartments(values);
      await updateLockedDepartments({
        variables: {
          id: lockedDepartments.id,
          data: {
            departments: values.map(d => d.id)
          }
        }
      });
      setLoading(false);
    }
  };
  return (
    <Grid item xs={12} md={6} className="locked-departments">
      <Autocomplete
        multiple
        options={departments}
        getOptionLabel={d => d.title}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={selectedDepartments}
        onChange={onDepartmentChange}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={lockedDepartments.entitlement}
            placeholder={t(translations.common.department())}
            margin="normal"
            fullWidth
          />
        )}
        renderTags={(value, getPropTags) => {
          return value.map((department, index) => (
            <Chip
              component={Paper}
              elevation={2}
              {...getPropTags({ index: index })}
              key={department.id}
              label={department.title}
              style={{
                fontSize: '11pt'
              }}
            />
          ));
        }}
      />
    </Grid>
  );
}
